import { Route, Routes } from "react-router-dom";

import HomePage from "../pages/HomePage/HomePage";
import LeaguePage from "../pages/LeaguePage/LeaguePage";
import AboutPage from "../pages/AboutPage/AboutPage";
import ResourcePage from "../pages/ResourcePage/ResourcePage";
import ContactPage from "../pages/ContactPage/ContactPage";
import CalendarPage from "../pages/CalendarPage/CalendarPage";
import TournamentPage from "../pages/TournamentPage/TournamentPage";
import NoticePage from "../pages/NoticePage/NoticePage";
import NewsPage from "../pages/NewsPage/NewsPage"


export default function Router() {
    return(
        <Routes>
            <Route path="" element={<HomePage />} />
            <Route path="/league" element={<LeaguePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/resource" element={<ResourcePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/notice" element={<NewsPage />} />
            <Route path="/notice/tournament" element={<TournamentPage />} />
            <Route path="/notice/:id" element={<NoticePage />} />
        </Routes>
    );
}